/**
 * CheTuo Web — Customer API functions.
 * Reuses /api/shop-mobile/customers/* endpoints.
 */

import { apiClient, shopMobilePath } from './client';

export interface Vehicle {
  id: string;
  plate: string;
  brand: string | null;
  model: string | null;
}

export interface CustomerWithVehicles {
  id: string;
  name: string;
  phone: string;
  remark: string | null;
  vehicles: Vehicle[];
}

export function listCustomers(q?: string): Promise<CustomerWithVehicles[]> {
  const qs = q ? `?q=${encodeURIComponent(q)}` : '';
  return apiClient.get<CustomerWithVehicles[]>(shopMobilePath(`/customers${qs}`));
}

export function createCustomer(input: { name: string; phone?: string; remark?: string }) {
  return apiClient.post<CustomerWithVehicles>(shopMobilePath('/customers'), input);
}

export function updateCustomer(
  customerId: string,
  input: Partial<{ name: string; phone: string; remark: string }>,
) {
  return apiClient.patch<CustomerWithVehicles>(
    shopMobilePath(`/customers/${customerId}`),
    input,
  );
}

export function deleteCustomer(customerId: string) {
  return apiClient.delete(shopMobilePath(`/customers/${customerId}`));
}

export function createVehicle(input: {
  customerId: string;
  plate: string;
  brand?: string;
  model?: string;
}) {
  return apiClient.post<Vehicle>(shopMobilePath('/vehicles'), input);
}

export function deleteVehicle(vehicleId: string) {
  return apiClient.delete(shopMobilePath(`/vehicles/${vehicleId}`));
}
